export const MULTIPLE_CHOICES = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export const DIGITAL_TIMER_WARNING_TIME = 300;

export const DISABLE_TEST_REPORT = [
    'epicacademics'
];

export const ENABLE_STUDENT_SIGNUP = [
    'veritas',
    'infiniteacademics',
    'maxpotentiallearning',
];